/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.sales.documents.rpc.SalesDocumentsFoldersService
 */

/**
 *  This class can be used as a response type in cases where no response is needed or
 *  where <code>void</code> might have been used in a REST-ful context.
 */

export const createFolderRpc = {
  serviceName: 'com.hubspot.sales.documents.rpc.SalesDocumentsFoldersService',
  rpcName: 'createFolder',
  auth: 'app',
  fingerprint: 'qeORV2a_sb96Td5oPv0lVLrKfBvmfLnC',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const deleteFolderRpc = {
  serviceName: 'com.hubspot.sales.documents.rpc.SalesDocumentsFoldersService',
  rpcName: 'deleteFolder',
  auth: 'app',
  fingerprint: 'RXoqKbFxHFmOUe2e_r4XmbrKfBvmfLnC',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getFoldersRpc = {
  serviceName: 'com.hubspot.sales.documents.rpc.SalesDocumentsFoldersService',
  rpcName: 'getFolders',
  auth: 'app',
  fingerprint: 'AAAAAAAAAABFu-QF31S3W7rKfBvmfLnC',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getFolderRpc = {
  serviceName: 'com.hubspot.sales.documents.rpc.SalesDocumentsFoldersService',
  rpcName: 'getFolder',
  auth: 'app',
  fingerprint: 'RXoqKbFxHFmwGJo0MB_Kq7rKfBvmfLnC',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const renameFolderRpc = {
  serviceName: 'com.hubspot.sales.documents.rpc.SalesDocumentsFoldersService',
  rpcName: 'renameFolder',
  auth: 'app',
  fingerprint: '4gTq1Ok_WMd6Td5oPv0lVLrKfBvmfLnC',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const updateFolderRpc = {
  serviceName: 'com.hubspot.sales.documents.rpc.SalesDocumentsFoldersService',
  rpcName: 'updateFolder',
  auth: 'app',
  fingerprint: 'MtlF8n4ysi96Td5oPv0lVLrKfBvmfLnC',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const moveDocumentsRpc = {
  serviceName: 'com.hubspot.sales.documents.rpc.SalesDocumentsFoldersService',
  rpcName: 'moveDocuments',
  auth: 'app',
  fingerprint: 'l3ayoJ9kllMSm0EFg5ED9LrKfBvmfLnC',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};